// @flow

import React from 'react';

function EllipsisLoader() {
  return (
    <div className="lds-ellipsis">
      <div />
      <div />
      <div />
      <div />
    </div>
  );
}

export default EllipsisLoader;
